export const EN = { code: 'en', language: 'English' }

export const allLanguages = [
  EN
]
